import type { Control } from 'react-hook-form';
import type { z } from 'zod';

import type { IdHeaderTagDto, IntegrationType } from '@/services/ws-header-tag/src/main/resources/rest-api';

import type { createSchema } from './schema.ts';

export type FormValues = z.input<ReturnType<typeof createSchema>>;
export type FormSubmitValues = z.output<ReturnType<typeof createSchema>>;

export interface TagFormRouteParams {
  integrationType: IntegrationType;
  headerTagId?: IdHeaderTagDto;
}

export interface FormFieldsProps {
  isSubmitting: boolean;
  control: Control<FormValues>;
  headerTagId?: IdHeaderTagDto;
  bidderIndex?: number;
}

export enum TagFormSearchKey {
  TAG_DETAILS_TAB = 'tagDetailsTab',
}
